<template>
  <div>
    <modal
      title="消息中心"
      :footer="null"
      v-bind="$attrs"
      v-on="$listeners"
      width="700px"
      :bodyStyle="{ padding: 0, height: '450px' }"
      :maskClosable="false"
    >
      <div class="noticeBox">
        <div class='side-box'>
          <div class="side-left">
            <div
              v-for="item in messageFirstMenuList"
              :class="`title-item ${item.id === activeId ? 'active' : ''}`"
              :key="item.id"
              @click="handleChangeTitle(item)"
            >
              {{ item.iconName }}
              <div class='flag-num' v-if="item.unreadCount">{{item.unreadCount > 99 ? '99+' : item.unreadCount}}</div>
            </div>

          </div>
          <a-button v-if='messageCurrentDetail.unReadAmount > 0' class="btn-all-readed" type='primary' ghost @click="handleBatchReaded()">全部已读</a-button>
        </div>

        <div class="content-box">
          <a-spin tip='加载中' :spinning="loading" class="spin-icon" v-if="loading"></a-spin>
          <template v-if="!loading">
            <a-empty  class="empty-icon" v-if="!messageDetailList || messageDetailList.length === 0"/>
            <div class='content-item-box'>
              <div class='content-item' v-for="item in messageDetailList" :key="item.id">
                <div class='title-box'>
                  <div class='unread-icon' v-if='item.isRead == 0'></div>
                  <div class='title'>{{ item.msgTitle }}</div>
                  <div class='time'>{{ transformTime(item.createTime)}}</div>
                </div>
                <div class='content'>
                  <img class='content-img' v-if="item.msgPicUrl" :src="item.msgPicUrl" alt="">
                  <div>{{item.msgContent}}</div>
                </div>
                <a-button v-if='item.web && item.web.jumpUrl' class="btn" type='primary' @click="handleClickCheck(item)">{{item.buttonName || '查看详情'}}</a-button>
                <a-button v-if='item.isRead == 0' class="markBtn" type='primary' ghost @click="handleClickMarkRead(item)">标记已读</a-button>

              </div>
            </div>
          </template>
          <div class="pagination">
            <a-pagination size="small" v-model="page" :total="total" :page-size="limit" @change="handleChangePage" />
          </div>
        </div>
      </div>
    </modal>
    <div :class="`new-message ${!showMessage ? 'hide' : ''}`">
      <div class="head">
        <span class="title">新消息（{{messageCurrentDetail.unReadAmount || 1}}）</span>
        <a-icon class='close-icon' type="close" @click='handelClickCloseMessage' />
      </div>
      <div class="content-box">
        <div class='content-item'>
          <div class='title-box'>
            <div class='unread-icon' v-if='messageCurrentDetail.isRead == 0'></div>
            <span class='title-content'>{{ messageCurrentDetail.msgTitle }}</span>
            <span class='time'>{{ transformTime(messageCurrentDetail.createTime)}}</span>
          </div>
          <div class='content'>
            <img class='content-img' v-if="messageCurrentDetail.msgPicUrl" :src="messageCurrentDetail.msgPicUrl" alt="">
            <div>{{messageCurrentDetail.msgContent}}</div>
          </div>
        </div>
      </div>
      <div class='btn-box'>
        <div class='btn btn-left' v-if='messageCurrentDetail.web && messageCurrentDetail.web.jumpUrl' @click="handleClickCheck(messageCurrentDetail)">{{messageCurrentDetail.buttonName || '查看详情'}}</div>
        <div class='btn' @click="handleClickAllMessage">全部消息</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { Button, Empty, Pagination, Icon, Spin, Modal } from "ant-design-vue";
  import dayjs from 'dayjs'
  import modal from "@/components/common-modal";

  export default {
    name: "notice-list-v2",
    components: {
      modal,
      [Button.name]: Button,
      [Empty.name]: Empty,
      [Pagination.name]: Pagination,
      [Icon.name]: Icon,
      [Spin.name]: Spin,
      [Modal.name]: Modal
    },
    data() {
      return {
        activeId: 0,
        page: 1,
        limit: 5,
        total: 0,
        showMessage: false,
        loading: false,
        timer1: null,
        timer2: null,
      };
    },
    async created() {
      this.scheduleGetMessageTips()
    },
    beforeDestroy() {
      clearTimeout(this.timer1)
      clearTimeout(this.timer2)
    },
    computed: {
      ...mapState(['messageFirstMenuList', 'messageDetailList', 'messageCurrentDetail']),
    },
    watch: {
      '$attrs.visible': function(newVal) {
        if (newVal) this.getMessageBox()
      }
    },
    methods: {
      ...mapActions(['getMessageFirstMenuList', 'getMessageDetailList', 'getMessageCurrentDetail', 'setMessageStatusByRead', 'setMessageUnReadTotal', 'setMessageListUnReadCount', 'setBatchMessageByReaded']),
      async handleChangeTitle(item) {
        if (this.activeId === item.id) return
        this.loading = true
        this.activeId = item.id
        this.total = item.msgCount
        this.page = 1
        await this.getMessageDetailList({
          msgIconId: item.id,
          start: this.page - 1,
          limit: this.limit
        })
        this.loading = false
      },
      async handleClickCheck(item) {
        const { isRead } = item
        item.web && item.web.jumpUrl && window.open(item.web.jumpUrl)
        if (isRead === 0) {
          const res = await this.setMessageStatusByRead(item.id)
          this.showMessage = false
          if (res) {
            this.setMessageUnReadTotal()
          }
        }
        this.$emit('handleChangeMessage', false)
      },
      async handleClickMarkRead(item) {
        const { isRead } = item
        if (isRead === 0) {
          this.showMessage = false
          const res = await this.setMessageStatusByRead(item.id)
          if (res) {
            this.setMessageListUnReadCount({activeId: this.activeId, itemId: item.id})
            this.setMessageUnReadTotal()
          }
        }
      },
      handelClickCloseMessage() {
        this.showMessage = false
      },
      transformTime (d) {
        return dayjs(d).format('YYYY-MM-DD HH:mm:ss')
      },
      async scheduleGetMessageTips() {
        await this.getMessageTips()
        const second = process.env.VUE_APP_SEVERENV === 'BETA' ? 2 * 60 * 1000 : 10 * 60 * 1000 
        this.timer2 = setTimeout(() => {
          this.scheduleGetMessageTips()
        }, second)
      },
      async getMessageBox() {
        this.loading = true
        await this.getMessageFirstMenuList()
        if (this.messageFirstMenuList && this.messageFirstMenuList.length > 0) {
          this.page = 1
          const cur = this.messageFirstMenuList[0]
          this.activeId = cur.id
          this.total = cur.msgCount
          await this.getMessageDetailList({
            msgIconId: cur.id,
            start: (this.page - 1) * this.limit,
            limit: this.limit
          })
        }
        this.loading = false
      },
      async getMessageTips() {
        await this.getMessageCurrentDetail()
        if (this.messageCurrentDetail && this.messageCurrentDetail.unReadAmount) {
          this.showMessage = true
          const second = process.env.VUE_APP_SEVERENV === 'BETA' ? 30 * 1000 : 60 * 1000 
          this.timer2 = setTimeout(() => {
            if (this.showMessage) this.showMessage = false
          }, second)
        }
      },
      async handleChangePage(page) {
        this.page = page
        this.loading = true
        await this.getMessageDetailList({
          msgIconId: this.activeId,
          start: (page - 1) * this.limit,
          limit: this.limit
        })
        this.loading = false
      },
      handleClickAllMessage() {
        this.showMessage = false
        this.$emit('handleChangeMessage', true)
      },
      handleBatchReaded() {
        Modal.confirm({
          icon: () => <i></i>,
          title: '是否确定全部已读？',
          // content: () => <div></div>,
          onOk: () => {
            this.showMessage = false
            this.setBatchMessageByReaded()
          },
        })
      }
    },
  };
</script>
<style lang="less">
.noticeBox {
  display: flex;
  height: 100%;
  font-size: 12px;
  color: #333333;
  .side-box{
    background: #f4f4f4;
    .btn-all-readed{
      margin-top: 8px;
      margin-left: 20px;
    }
  }
  .side-left {
    width: 130px;
    background: #f4f4f4;
    overflow: auto;
    height: 400px;
    .title-item {
      cursor: pointer;
      height: 36px;
      display: flex;
      align-items: center;
      padding-left: 15px;
    }
    .active {
      background: #ffffff;
    }
    .flag-num{
      color: #FFFFFF;
      background: #FF3232;
      border-radius: 7px;
      border-radius: 7px;
      min-width: 15px;
      padding: 0 4px;
      height: 15px;
      margin-left: 4px;
      line-height: 15px;
      text-align: center;
    }
  }
  .content-box {
    width: 100%;
    padding-bottom: 50px;
    position: relative;
    .empty-icon{
      margin-top: 100px;
    }
    .content-item-box{
      height: 100%;
      overflow: auto;
    }
    .content-item{
      border-bottom: 1px solid #eeeeee;
      padding: 0 20px 15px;
      .title-box{
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .unread-icon{
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background: #FF3232;
          left: -12px;
        }
        .title{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 430px;
        }
        .time{
          font-size: 10px;
          color: #999999;
        }
      }
      .content{
        margin-top: 10px;
        font-size: 10px;
        color: #666666;
        line-height: 18px;
        overflow: hidden;
        overflow-y: auto;
        max-height: 100px;
        word-break: break-word;
        // display: flex;
        // align-items: center;
        .content-img{
          float: left;
          width: 32px;
          height: 32px;
          margin-right: 10px;
          margin-top: 3px;
        }
      }
      .btn{
        margin-top: 15px;
        margin-right: 20px;
      }
      .markBtn{
        margin-top: 15px;
      }
    }
    .pagination{
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      bottom: 0;
      height: 50px;
      width: 100%;
      padding: 0 15px;
    }
  }
}
.new-message{
  width: 280px;
  height: 196px;
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 999;
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.30);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all .5s;
  .head {
    height: 38px;
    background-image: linear-gradient(180deg, #007AFF 0%, #1C7AE5 100%);
    border-radius: 4px 4px 0 0;
    color: #FFFFFF;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    .close-icon{
      height: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 20px;
      justify-content: center;
    }
  }
  .content-box{
      margin-left: 16px;
      height: 100%;
    .content-item{
      padding-right: 16px;
      padding-bottom: 11px;
      .title-box{
        line-height: 20px;
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        // height: 20px;
        .unread-icon{
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background: #FF3232;
          left: -12px;
        }
        .title-content{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 130px;
          font-size: 12px;
          color: #333333;
        }
        .time{
          font-size: 10px;
          color: #999999;
        }
      }
      .content{
        margin-top: 8px;
        font-size: 10px;
        color: #666666;
        line-height: 14px;
        max-height: 60px;
        overflow-y: auto;
        word-break: break-word;
        // display: flex;
        // align-items: center;
        .content-img{
          float: left;
          width: 60px;
          height: 60px;
          margin-right: 16px;
        }

      }

    }
  }
  .btn-box{
    min-height: 44px;
    display: flex;
    align-items: center;
    border-top: 1px solid #EEEEEE;
    .btn{
      flex: 1;
      height: 16px;
      cursor: pointer;
      font-size: 12px;
      color: #1C7AE5;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn-left{
      border-right: 1px solid #EEEEEE;
    }
  }
}
.hide{
  opacity: 0;
  visibility: hidden;
}
.spin-icon{
  width: 100%;
  margin-top: 100px;
  margin-left: -20px;
}
</style>
